import { render, staticRenderFns } from "./DetailsBranding.vue?vue&type=template&id=54fd7346&scoped=true&"
import script from "./DetailsBranding.vue?vue&type=script&lang=js&"
export * from "./DetailsBranding.vue?vue&type=script&lang=js&"
import style0 from "./DetailsBranding.vue?vue&type=style&index=0&id=54fd7346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd7346",
  null
  
)

export default component.exports